/** @jsx jsx */
import PropTypes from 'prop-types'
import { Box, Flex, Grid, jsx } from 'theme-ui'
import { useLocation } from '@reach/router'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import Text from '~/components/IntlComponents/Text'
import { toURL } from '~/utils/intl/localePrefix'
import Sublink from '~/components/Nav/NavMenu/Sublink'
const FooterLinks = ({ catalog, links }) => {
  const location = useLocation()
  const translate = useTranslate()
  return (
    <Flex
      sx={{
        borderBottom: [null, '1px solid', 'none'],
        flexDirection: ['row'],
        flexWrap: ['wrap', 'unset'],
        textAlign: ['left'],
        justifyContent: 'space-between',
        width: ['100%', null, '50%'],
        marginTop: [40, 90],
      }}
    >
      <Box
        sx={{
          lineHeight: ['35px', 'inherit'],
          padding: ['1.5rem 0', null, '0'],
          width: ['30%', '100%'],
        }}
      >
        <Text
          variant="text.eyebrow.uppercase"
          as="div"
          sx={{ paddingBottom: [10, 20] }}
        >
          {translate('footer.shop.title')}
        </Text>
        <Grid sx={{ gap: [15, 20], textTransform: 'capitalize' }}>
          {catalog.collections
            .filter(
              ({ slug, hidden }) =>
                // new launch is a collection that is hidden from everywhere
                // except via direct link to the collection on shopall page
                // "/shop?collection=new-launch"
                slug !== 'kits' &&
                // && !slug?.includes('new-launch')
                !hidden,
            )
            .map(item => (
              <Sublink
                forwardSx={{
                  fontFamily: 'heading',
                  fontSize: ['16px', '20px'],
                  lineHeight: ['18px', '24px'],
                }}
                key={item.id}
                slug={item.slug}
                contenttype={item.__typename}
              >
                {item.title}
              </Sublink>
            ))}

          <Sublink
            forwardSx={{
              fontFamily: 'heading',
              fontSize: ['16px', '20px'],
              lineHeight: ['18px', '24px'],
            }}
            contenttype="ContentfulPage"
            slug={`/shop/`}
          >
            {translate('generic.shop_all')}
          </Sublink>
        </Grid>
      </Box>

      {links.map(navSection => {
        let { pages } = navSection
        return (
          <Box
            key={navSection.id}
            sx={{
              lineHeight: ['35px', 'inherit'],
              padding: ['1.5rem 0', null, '0'],
              width: ['30%', '100%'],
            }}
          >
            <Text
              variant="text.eyebrow.uppercase"
              as="div"
              sx={{ paddingBottom: [10, 20] }}
            >
              {navSection.navSectionTitle}
            </Text>

            <Grid sx={{ gap: [15, 20] }}>
              {pages.map(item => {
                return (
                  <Sublink
                    forwardSx={{
                      fontFamily: 'heading',
                      fontSize: ['16px', '20px'],
                      lineHeight: ['18px', '24px'],
                    }}
                    key={item.id}
                    contenttype={item.__typename}
                    slug={item.slug}
                  >
                    {item.name}
                  </Sublink>
                )
              })}
            </Grid>
          </Box>
        )
      })}
    </Flex>
  )
}

FooterLinks.propTypes = {
  catalog: PropTypes.shape({
    collections: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        slug: PropTypes.string,
      }),
    ),
  }),
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
  ),
}

export default FooterLinks
